import axios from 'axios';
import { get } from 'lodash';

export default {
    async getForms(){
        const apiResponse = await axios.get(`/api/form/`);
        return apiResponse;
    },

    async getFormsOfType(formType){
        const apiResponse = await axios.get(`/api/form/formsoftype?formType=${formType}`);
        return apiResponse;
    },

    async getForm(formId, preferDraft = false){
        const apiResponse = await axios.get(`/api/form/${formId}?preferDraft=${preferDraft}`);
        return apiResponse;
    },

    async postCreateForm(formName, formType){
        const apiResponse = await axios.post(`/api/form/`, {
            formName,
            formType
        });

        return apiResponse;
    },

    async postSaveChanges(formId, payload){
        const apiResponse = await axios.post(`/api/form/${formId}`, payload);

        return apiResponse;
    },

    async postPublishForm(formId, formVersionId){
        const apiResponse = await axios.post(`/api/form/${formId}/publish?formVersionId=${formVersionId}`);

        return apiResponse;
    },

    async getFormResponse(formId, formResponseId){
        const apiResponse = await axios.get(`/api/form/${formId}/response/${formResponseId}`);
        return apiResponse;
    },

    async postFormResponse(formId, formResponseId, payload){
        const apiResponse = await axios.post(`/api/form/${formId}/response/${formResponseId ?? ''}`, payload);
        return apiResponse;
    },

    async postCopyFields(formId, sourceFormId){
        const apiResponse = await axios.post(`/api/form/${formId}/copyfields?sourceFormid=${sourceFormId}`);

        return apiResponse;
    },

    async deleteForm(formId){
        const apiResponse = await axios.delete(`/api/form/${formId}`);
        return apiResponse;
    }
}